import { NSAHomePage, NSARouterMakerResult } from "namirasoft-account-react";
import { ProjectRow } from "namirasoft-infra";
import { NSCard, NSColumn, NSLoading, NSTitle } from "namirasoft-site-react";
import { Component } from "react";
import { InfraImages } from "../InfraImages";
import { InfraLayout } from "../InfraLayout";
import { InfraRouterProps } from "../InfraRouterProps";
import { InfraRoutes } from "../InfraRoutes";

interface HomePageProps extends NSARouterMakerResult, InfraRouterProps { }
interface HomePageState
{
    projects?: ProjectRow[];
    loading: boolean;
}

class HomePage extends Component<HomePageProps, HomePageState>
{
    constructor(props: HomePageProps)
    {
        super(props);
        this.state = { loading: true }
    }

    override componentDidMount(): void
    {
        this.props.servers.infra.project
            .List([], null, null, [], null)
            .then((response) => this.setState(() => ({ projects: response.rows, loading: false })))
            .catch(() => this.setState(() => ({ loading: false })))
    }

    override render()
    {
        return (
            <InfraLayout {...this.props}>
                {
                    this.state.loading
                        ?
                        <NSLoading />
                        :
                        <NSAHomePage
                            {...this.props}
                            getChildren={{
                                getChildrenAfterTitle: () => this.state.projects?.map(project => (
                                    <NSColumn classList={["align-items-center"]}>
                                        <NSTitle title={"Projects"} style={{ fontSize: 32 }} />
                                        <NSCard
                                            title={project.name}
                                            description={project.description ?? ""}
                                            image={{ src: InfraImages.project, alt: "Project" }}
                                            link={{ href: InfraRoutes.EnvironmentSelect(project.id), target: "_self" }}
                                        />
                                    </NSColumn>
                                ))
                            }}
                        />
                }
            </InfraLayout>
        )
    }
}

export default HomePage;